/**
 * GoNOW API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 2020-12-7
 * Contact: info@zero-spec.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import Options from './Options';
import SupplyResponse from './SupplyResponse';

/**
* The SearchCustomerSupplyResponse model module.
* @module model/SearchCustomerSupplyResponse
* @version 2020-12-7
*/
export default class SearchCustomerSupplyResponse {
    /**
    * Constructs a new <code>SearchCustomerSupplyResponse</code>.
    * 顧客給油量取得レスポンス
    * @alias module:model/SearchCustomerSupplyResponse
    * @class
    * @param supplies {Array.<module:model/SupplyResponse>} 給油量
    * @param result {module:model/SearchCustomerSupplyResponse.ResultEnum} 
    */

    constructor(supplies, result) {
        
        
        this['supplies'] = supplies;
        this['result'] = result;
        
    }

    /**
    * Constructs a <code>SearchCustomerSupplyResponse</code> from a plain JavaScript object, optionally creating a new instance.
    * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
    * @param {Object} data The plain JavaScript object bearing properties of interest.
    * @param {module:model/SearchCustomerSupplyResponse} obj Optional instance to populate.
    * @return {module:model/SearchCustomerSupplyResponse} The populated <code>SearchCustomerSupplyResponse</code> instance.
    */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new SearchCustomerSupplyResponse();
                        
            
            if (data.hasOwnProperty('supplies')) {
                obj['supplies'] = ApiClient.convertToType(data['supplies'], [SupplyResponse]);
            }
            if (data.hasOwnProperty('result')) {
                obj['result'] = ApiClient.convertToType(data['result'], 'String');
            }
            if (data.hasOwnProperty('options')) {
                obj['options'] = Options.constructFromObject(data['options']);
            }
        }
        return obj;
    }

    /**
    * 給油量
    * @member {Array.<module:model/SupplyResponse>} supplies
    */
    'supplies' = undefined;
    /**
    * @member {module:model/SearchCustomerSupplyResponse.ResultEnum} result
    */
    'result' = undefined;
    /**
    * @member {module:model/Options} options
    */
    'options' = undefined;



    /**
    * Allowed values for the <code>result</code> property.
    * @enum {String}
    * @readonly
    */
    static ResultEnum = {
        /**
         * value: "NG"
         * @const
         */
        "NG": "NG",
        /**
         * value: "OK"
         * @const
         */
        "OK": "OK"    };

}
